import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClienteRoutingModule } from './cliente-routing.module';
import { ListaComponent } from './pages/lista/lista.component';
import {ComponentesModule} from "../../../core/componentes/componentes.module";
import {ReactiveFormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxMaskDirective} from "ngx-mask";
import { PaginaDetalhesComponent } from './pages/pagina-detalhes/pagina-detalhes.component';


@NgModule({
  declarations: [
    ListaComponent,
    PaginaDetalhesComponent
  ],
    imports: [
        CommonModule,
        ClienteRoutingModule,
        ComponentesModule,
        ReactiveFormsModule,
        NgSelectModule,
        NgxMaskDirective
    ]
})
export class ClienteModule { }
